var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5002 39.4167C31.3953 39.4167 39.4168 31.3951 39.4168 21.5C39.4168 11.6049 31.3953 3.58337 21.5002 3.58337C11.6051 3.58337 3.5835 11.6049 3.5835 21.5C3.5835 31.3951 11.6051 39.4167 21.5002 39.4167ZM26.251 19.0842C26.7758 18.5595 26.7758 17.7087 26.251 17.1839C25.7262 16.6591 24.8754 16.6591 24.3507 17.1839L21.5001 20.0344L18.6496 17.1839C18.1248 16.6591 17.274 16.6591 16.7493 17.1839C16.2245 17.7087 16.2245 18.5595 16.7493 19.0842L19.5998 21.9348L16.7493 24.7853C16.2245 25.3101 16.2245 26.1609 16.7493 26.6856C17.274 27.2104 18.1248 27.2104 18.6496 26.6856L21.5001 23.8351L24.3507 26.6856C24.8754 27.2104 25.7262 27.2104 26.251 26.6856C26.7758 26.1609 26.7758 25.3101 26.251 24.7853L23.4005 21.9348L26.251 19.0842Z",
    fill: "#FF5146"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.ffd9011cbe62a441092a9d37c215a5fd.svg";
export { ForwardRef as ReactComponent };